import Routes from "./module/routes";
import Store from "./module/store";

export default {
  name: "user",
  routes: Routes,
  store: Store
};
